import { guideSteps } from "@/mocks/comicData";

export default function Guide() {
  return (
    <section id="guide" className="bg-background-950 py-16 md:py-24">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="mx-auto mb-14 max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-500/15 px-3 py-1 text-xs font-medium text-accent-300">
            <i className="ri-tools-line" />
            打开指南
          </span>
          <h2 className="font-heading mt-4 text-3xl text-background-50 md:text-4xl">
            页面打不开？按步骤排查
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-background-100/80 md:text-base">
            虚空漫画网偶发无法打开时，多半与网络环境、缓存或入口状态有关。逐项对照以下步骤，绝大多数情况都能顺利恢复访问。
          </p>
        </div>

        <div className="relative mx-auto max-w-3xl">
          <span className="absolute left-5 top-2 bottom-2 w-px bg-background-700 md:left-6" />
          <div className="space-y-5">
            {guideSteps.map((step, idx) => (
              <div key={step.title} className="relative flex items-start gap-5 pl-0">
                <span className="relative z-10 flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-background-700 bg-background-900 text-accent-300 md:h-12 md:w-12">
                  <i className={`${step.icon} text-lg md:text-xl`} />
                </span>
                <div className="rounded-lg border border-background-800 bg-background-900 p-5 md:p-6">
                  <h3 className="flex items-center gap-2 text-base font-bold text-background-50 md:text-lg">
                    <span className="font-heading text-accent-400">0{idx + 1}</span>
                    {step.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-background-100/75">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 text-center">
          <a
            href="#entrance"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById("entrance")?.scrollIntoView({ behavior: "smooth" });
            }}
            className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-7 py-3.5 text-base font-bold text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
          >
            前往备用入口
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}